"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _monthCostManagementJP = require("@/api/monthCostManagementJP/monthCostManagementJP");
var _roleCertificationApplication = require("@/api/user/roleCertificationApplication/roleCertificationApplication");
var _vuex = require("vuex");
var _index = _interopRequireDefault(require("@/components/SailScheduleOne/index.vue"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "monthCostManagementJP",
  components: {
    sailSchedule: _index.default
  },
  data: function data() {
    return {
      userInfo: [],
      vesselCode: '',
      searchForm: {
        // etaFrom: '2024-07-01',
        // etaTo: '2024-07-19',
        etaFrom: '',
        etaTo: '',
        payFrom: '',
        payTo: '',
        agent: '',
        customer: '',
        consignee: '',
        shipper: '',
        blNo: '',
        pol: '',
        pod: '',
        vessel: '',
        voyage: '',
        status: ''
      },
      confirmStatusList: [{
        value: 'AY',
        label: 'Agent Confirm YES'
      }, {
        value: 'AN',
        label: 'Agent Confirm NO'
      }, {
        value: 'CY',
        label: 'Customer Confirm YES'
      }, {
        value: 'CN',
        label: 'Customer Confirm NO'
      }, {
        value: 'SY',
        label: 'SITC Confirm YES'
      }, {
        value: 'SN',
        label: 'SITC Confirm NO'
      }],
      selectDataAgent: [],
      selectDataCustomer: [],
      sailScheduleDialogVisible: false,
      smallMonthThree: '',
      largeMonthThree: '',
      rules: {
        agent: [{
          validator: this.validateAgent,
          trigger: 'blur'
        }],
        customer: [{
          validator: this.validateCustomer,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    this.searchForm.etaFrom = this.getNumberDate('day', -10);
    this.smallMonthThree = this.getNumberDate('month', -3);
    this.largeMonthThree = this.getNumberDate('month', 3);
    this.searchForm.etaTo = this.getNumberDate('day', 3);
  },
  mounted: function mounted() {
    this.queryListInfo();
  },
  methods: {
    validateAgent: function validateAgent(rule, value, callback) {
      if ((0, _validate.validateNull)(value) && this.userInfo.accountType === 3) {
        callback(new Error('An agent is not null'));
      } else {
        callback();
      }
    },
    validateCustomer: function validateCustomer(rule, value, callback) {
      if ((0, _validate.validateNull)(value) && this.userInfo.accountType === 2) {
        callback(new Error('Credit Customer is not null'));
      } else {
        callback();
      }
    },
    queryListInfo: function queryListInfo() {
      var _this = this;
      (0, _roleCertificationApplication.queryListInfo)({
        currentPage: 1,
        pageSize: 10
      }).then(function (res) {
        if (res.success) {
          _this.userInfo = res.data.ebSysAccount;
          _this.getSelectCREDIT_CUSTOMER();
          _this.getSelectCREDIT_AGENT();
        } else {
          _this.$message.error(res.errorMessages[0]);
        }
      }).finally(function () {});
    },
    vesselChange: function vesselChange(row, value) {
      console.log('row,value', row, value);
      this.vesselCode = value.vesselCode;
    },
    getNumberDate: function getNumberDate(type, number) {
      var nowdate = new Date();
      var y = '';
      var m = '';
      var d = '';
      var retrundate = '';
      var weekdate = '';
      switch (type) {
        case "day":
          //取number天前、后的时间
          nowdate.setTime(nowdate.getTime() + 24 * 3600 * 1000 * number);
          y = nowdate.getFullYear();
          m = nowdate.getMonth() + 1;
          d = nowdate.getDate();
          retrundate = y + '-' + m + '-' + d;
          break;
        case "week":
          //取number周前、后的时间
          weekdate = new Date(nowdate + 7 * 24 * 3600 * 1000 * number);
          y = weekdate.getFullYear();
          m = weekdate.getMonth() + 1;
          d = weekdate.getDate();
          retrundate = y + '-' + m + '-' + d;
          break;
        case "month":
          //取number月前、后的时间
          nowdate.setMonth(nowdate.getMonth() + number);
          y = nowdate.getFullYear();
          m = nowdate.getMonth() + 1;
          d = nowdate.getDate();
          retrundate = y + '-' + m + '-' + d;
          break;
        case "year":
          //取number年前、后的时间
          nowdate.setFullYear(nowdate.getFullYear() + number);
          y = nowdate.getFullYear();
          m = nowdate.getMonth() + 1;
          d = nowdate.getDate();
          retrundate = y + '-' + m + '-' + d;
          break;
        default:
          //取当前时间
          y = nowdate.getFullYear();
          m = nowdate.getMonth() + 1;
          d = nowdate.getDate();
          retrundate = y + '-' + m + '-' + d;
      }
      return retrundate;
    },
    selectionChangeSailSchedule: function selectionChangeSailSchedule(row) {
      this.sailScheduleDialogVisible = false;
      this.searchForm.vessel = row.vesselCode;
      this.searchForm.voyage = row.voyageNo + row.voyageLeg;
    },
    handleOpenVessel: function handleOpenVessel() {
      this.sailScheduleDialogVisible = true;
    },
    getSelectCREDIT_AGENT: function getSelectCREDIT_AGENT() {
      var _this2 = this;
      (0, _monthCostManagementJP.queryListCodeNameCREDIT_AGENT)().then(function (res) {
        _this2.selectDataAgent = res.data;
        if (_this2.userInfo.accountType === 3) {
          _this2.searchForm.agent = res.data.toString();
        }
      });
    },
    getSelectCREDIT_CUSTOMER: function getSelectCREDIT_CUSTOMER() {
      var _this3 = this;
      (0, _monthCostManagementJP.queryListCodeCREDIT_CUSTOMER)().then(function (res) {
        _this3.selectDataCustomer = res.data;
        if (res.data.length === 1) {
          _this3.searchForm.customer = res.data[0];
        }
      });
    },
    searchFormData: function searchFormData() {
      var _this4 = this;
      this.$refs['searchFormRef'].validate(function (valid) {
        if (valid) {
          console.log('this.searchForm', _this4.searchForm);
          _this4.searchForm.consignee = _this4.searchForm.consignee.trim();
          _this4.searchForm.shipper = _this4.searchForm.shipper.trim();
          _this4.searchForm.blNo = _this4.searchForm.blNo.trim();
          _this4.searchForm.consignee = _this4.searchForm.consignee.trim();
          if (_this4.searchForm.etaFrom == '' || _this4.searchForm.etaTo == '') {
            _this4.$message({
              message: 'ETA can not be null',
              type: 'warning'
            });
            return;
          }

          // if( new Date(this.searchForm.etaFrom )< new Date(this.smallMonthThree)){
          //   this.$message({
          //     message:'ETA time can not more than three months',
          //     type: 'warning'
          //   })
          //   return
          // }

          var dateForm = new Date(_this4.searchForm.etaFrom).getTime();
          var dateFormTo = new Date(_this4.searchForm.etaTo).getTime();
          var day = parseInt((dateFormTo - dateForm) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
          console.log('day', day);
          if (day > 90) {
            _this4.$message({
              message: 'ETA time can not more than three months',
              type: 'warning'
            });
            return;
          }
          // if( new Date(this.searchForm.etaTo ) > new Date(this.largeMonthThree)){
          //   this.$message({
          //     message:'ETA time can not more than three months',
          //     type: 'warning'
          //   })
          //   return
          // }

          _this4.$router.push({
            path: '/settlementManagement/monthCostManagementJPTable',
            query: {
              searchForm: JSON.stringify(_this4.searchForm)
            }
          });
        }
      });
    },
    resetForm: function resetForm() {
      this.vesselCode = '';
      this.searchForm.payFrom = '';
      this.searchForm.payTo = '';
      this.searchForm.agent = '';
      this.searchForm.customer = '';
      this.searchForm.consignee = '';
      this.searchForm.shipper = '';
      this.searchForm.blNo = '';
      this.searchForm.pol = '';
      this.searchForm.pod = '';
      this.searchForm.vessel = '';
      this.searchForm.voyage = '';
      this.searchForm.status = '';
    }
  }
};